import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useMobileChrome } from './MobileChrome';

/**
 * The bottom action bar for phone forms and editors (Save, Next, Send): the
 * last child of a scrolling column, it sticks to the bottom and stays above
 * the keyboard. It pads for the home indicator only when the tab bar is out
 * of the way, since the tab bar already covers it.
 */
export function StickyActionBar({ children, className }: { children: ReactNode; className?: string }) {
	const { tabBarHidden } = useMobileChrome();
	return (
		<div
			className={cn(
				'sticky bottom-0 z-20 mt-auto flex shrink-0 items-center gap-2 border-t border-border/60 bg-background/90 px-4 pt-2 backdrop-blur-xl supports-[backdrop-filter]:bg-background/75',
				'[&>button]:h-11 [&>button]:text-[15px]',
				tabBarHidden ? 'pb-[max(0.5rem,var(--safe-bottom))] kb-open:pb-2' : 'pb-2',
				className,
			)}
		>
			{children}
		</div>
	);
}
